import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import DeleteIcon from '@material-ui/icons/Delete';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import IconButton from '../../UI/IconButton';
import messages from './CommunicatorDialog.messages';

class CommunicatorDialogBoardItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      openDeleteBoard: false,
      deleteError: null
    };
  }

  handleDialogClose = () => {
    this.setState({ openDeleteBoard: false, deleteError: null });
  };

  handleBoardDelete = async (board) => {
    this.setState({ deleteError: null, loading: true });
    try {
      await this.props.deleteBoard(board);
      this.setState({ openDeleteBoard: false });
    } catch (err) {
      this.setState({ deleteError: err.message });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { board, intl } = this.props;
    const title = board.nameKey || board.name || board.id;
    const boardCaption = board.caption;

    return (
      <div className="CommunicatorDialog__boards__item">
        <div className="CommunicatorDialog__boards__item__image">
          {!!boardCaption && (
            <div className="CommunicatorDialog__boards__item__image_container">
              <img src={boardCaption} alt={title} />
            </div>
          )}
          {!boardCaption && (
            <div className="CommunicatorDialog__boards__item__image__empty">
              <ViewModuleIcon className="CommunicatorDialog__boards__item__image__empty ViewModuleIcon" />
            </div>
          )}
        </div>
        <div className="CommunicatorDialog__boards__item__data">
          <div className="CommunicatorDialog__boards__item__data__title">
            <ListItem disableGutters={true}>
              <ListItemText
                primary={title}
                secondary={intl.formatMessage(messages.tilesQty, {
                  qty: board.tiles ? board.tiles.length : 0
                })}
              />
            </ListItem>
          </div>
        </div>
        <div>
          {this.state.loading && <CircularProgress size={25} thickness={7} />}
        </div>
        <div className="CommunicatorDialog__boards__item__actions">
          <IconButton
            label={intl.formatMessage(messages.deleteBoard)}
            onClick={() => this.setState({ openDeleteBoard: true })}
          >
            <DeleteIcon />
          </IconButton>

          <Dialog
            onClose={this.handleDialogClose}
            aria-labelledby="board-delete-dialog"
            open={this.state.openDeleteBoard}
          >
            <DialogTitle id="board-delete-title">
              {intl.formatMessage(messages.deleteBoard)}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {intl.formatMessage(messages.deleteBoardDescription)}
              </DialogContentText>
              {this.state.deleteError && (
                <DialogContentText style={{ color: 'red', marginTop: 8 }}>
                  {this.state.deleteError}
                </DialogContentText>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDialogClose} color="primary">
                {intl.formatMessage(messages.close)}
              </Button>
              <Button
                onClick={() => this.handleBoardDelete(board)}
                variant="contained"
                color="primary"
              >
                {intl.formatMessage(messages.accept)}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

CommunicatorDialogBoardItem.propTypes = {
  intl: intlShape,
  board: PropTypes.object,
  deleteBoard: PropTypes.func.isRequired
};

export default CommunicatorDialogBoardItem;
